<template>
  <div>
    <div class="app-notification-list-wrapper cards-wrapper" v-if="showSingleNotification >= 0">
      <div class="single-notification" v-if="showSingleNotification === 1">
<!--       (inaktiv) Abo Option -->
        <IndividualNotificationBanner v-if="showAboOptionPromotion"
                                      :addCardClass="true"
                                      :text-notifications="{button: false}">
          <template v-slot:txtIndividualTextNotification>
            <slot :name="aboPromoSlot"></slot>
          </template>
        </IndividualNotificationBanner>
<!--        Adventskalender -->
        <IndividualNotificationBanner v-if="showAdventNotification && !this.inWebView"
                                      :addCardClass="true"
                                      :text-notifications="{button: false}"
                                      class="withRibbon">
          <template v-slot:txtBeforeIndividualTextNotification>
            <slot name="txtBeforeNotificationAdvent"></slot>
          </template>
          <template v-slot:txtIndividualTextNotification>
            <slot name="txtNotificationAdventWeb"></slot>
          </template>
        </IndividualNotificationBanner>
        <IndividualNotificationBanner v-if="showAdventNotification && this.inWebView"
                                      :addCardClass="true"
                                      :text-notifications="{button: true}"
                                      class="withRibbon">
          <template v-slot:txtBeforeIndividualTextNotification>
            <slot name="txtBeforeNotificationAdvent"></slot>
          </template>
          <template v-slot:txtIndividualTextNotification>
            <slot name="txtNotificationAdventApp"></slot>
          </template>
          <template v-slot:btnIndividualTextNotification>
            <slot name="btnNotificationAdventApp"></slot>
          </template>
        </IndividualNotificationBanner>
<!--       (innerhalb des ersten Monats nach Vertragsbeginn, wenn SIM Karte) Free ESim -->
        <IndividualNotificationBanner v-if="showFreeEsimNotification"
                                      :addCardClass="true"
                                      :text-notifications="{button: true}">
          <template v-slot:txtIndividualTextNotification>
            <dyn-slot :slot-data="slotData">
              <slot name="txtNotificationFreeEsimAvailable"></slot>
            </dyn-slot>
          </template>
          <template v-slot:btnIndividualTextNotification>
            <a :href="esimTargetUrl" class="button filled white">
              <slot name="btnNotificationFreeEsimAvailable"></slot>
            </a>
          </template>
        </IndividualNotificationBanner>
<!--        (aktiv) Cancelled Tariff -->
        <CancelledTariffBanner
          :addCardClass="true"
          :from-wrapper="true"
          :contract-state="contractState"
          :showBanner.sync="notificationComponents.showCancelledBanner.isShown"
        >
          <template v-for="slot in possibleChildSlotsFor('CancelledTariff')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </CancelledTariffBanner>
<!--        (aktiv) Email Confirm Missing -->
        <EMailConfirmationMissing :inline-layout="false" :showBox.sync="notificationComponents.showEmailBanner.isShown">
          <template v-for="slot in possibleChildSlotsFor('EMailConfirmationMissing')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </EMailConfirmationMissing>
<!--       (inaktiv) Booked Promo -->
        <BookedPromoNotificationBanner :addCardClass="true"
                                       :from-wrapper="true"
                                       :showBanner.sync="notificationComponents.showPromotionBanner.isShown"
                                       :promoIdList="promoIdList"
        >
          <template v-for="slot in possibleChildSlotsFor('BookedPromoNotificationBanner')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </BookedPromoNotificationBanner>
<!--        Individual Text Banner -->
        <IndividualNotificationBanner
          :addCardClass="true"
          :text-notifications="activeIndividueltextBanner[0]"
          v-if="this.activeIndividueltextBanner.length === 1">
          <template v-for="slot in possibleChildSlotsFor('IndividualBanner', activeIndividueltextBanner[0].name)"
                    v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </IndividualNotificationBanner>
      </div>
      <div v-else-if="showSingleNotification > 1" class="accordion card">
        <div class="accordion-header">
          <dyn-slot :slot-data="slotData">
            <slot name="txtAccordionHeader"></slot>
          </dyn-slot>
          <div class="accordion-btn-wrapper">
            <b-button :class="['accordion-toggle', {open: visible}]" @click="visible = !visible">
              <slot name="btnToggleClosed" v-if="!visible"></slot>
              <slot name="btnToggleOpen" v-if="visible"></slot>
            </b-button>
          </div>
        </div>
        <div class="accordion-content">
          <b-collapse v-model="visible">
<!--        Adventskalender -->
            <IndividualNotificationBanner v-if="showAdventNotification && !this.inWebView"
                                          :addCardClass="false"
                                          :text-notifications="{button: false}"
                                          class="withRibbon">
              <template v-slot:txtBeforeIndividualTextNotification>
                <slot name="txtBeforeNotificationAdvent"></slot>
              </template>
              <template v-slot:txtIndividualTextNotification>
                <slot name="txtNotificationAdventWeb"></slot>
              </template>
            </IndividualNotificationBanner>
            <IndividualNotificationBanner v-if="showAdventNotification && this.inWebView"
                                          :addCardClass="false"
                                          :text-notifications="{button: true}"
                                          class="withRibbon">
              <template v-slot:txtBeforeIndividualTextNotification>
                <slot name="txtBeforeNotificationAdvent"></slot>
              </template>
              <template v-slot:txtIndividualTextNotification>
                <slot name="txtNotificationAdventApp"></slot>
              </template>
              <template v-slot:btnIndividualTextNotification>
                <slot name="btnNotificationAdventApp"></slot>
              </template>
            </IndividualNotificationBanner>
<!--        Individual Text Banner -->
            <IndividualNotificationBanner
              :text-notifications="note"
              v-for="note in activeIndividueltextBanner"
              :key="note.name"
            >
              <template v-for="slot in possibleChildSlotsFor('IndividualBanner', note.name)" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </IndividualNotificationBanner>
<!--        Abo Option -->
            <IndividualNotificationBanner v-if="showAboOptionPromotion"
                                          :text-notifications="{button: false}">
              <template v-slot:txtIndividualTextNotification>
                <slot :name="aboPromoSlot"></slot>
              </template>
            </IndividualNotificationBanner>
<!--        Free ESim -->
            <IndividualNotificationBanner v-if="showFreeEsimNotification"
                                          :text-notifications="{button: true}">
              <template v-slot:txtIndividualTextNotification>
                <dyn-slot :slot-data="slotData">
                  <slot name="txtNotificationFreeEsimAvailable"></slot>
                </dyn-slot>
              </template>
              <template v-slot:btnIndividualTextNotification>
                <a :href="esimTargetUrl" class="button filled white">
                  <slot name="btnNotificationFreeEsimAvailable"></slot>
                </a>
              </template>
            </IndividualNotificationBanner>
<!--        Cancelled Tariff -->
            <CancelledTariffBanner
              :from-wrapper="true"
              :showBanner.sync="notificationComponents.showCancelledBanner.isShown"
              :contract-state="contractState"
            >
              <template v-for="slot in possibleChildSlotsFor('CancelledTariff')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </CancelledTariffBanner>
<!--        Email Confirm Missing -->
            <EMailConfirmationMissing :inline-layout="true" button-class="filled white"
                                      :showBox.sync="notificationComponents.showEmailBanner.isShown">
              <template v-for="slot in possibleChildSlotsFor('EMailConfirmationMissing')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </EMailConfirmationMissing>
<!--        Booked Promo -->
            <BookedPromoNotificationBanner
              :from-wrapper="true"
              :showBanner.sync="notificationComponents.showPromotionBanner.isShown"
              :promoIdList="promoIdList"
            >
              <template v-for="slot in possibleChildSlotsFor('BookedPromoNotificationBanner')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </BookedPromoNotificationBanner>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useFeature from '@/mixins/useFeature'
import EMailConfirmationMissing
from '@/components/process/generic/ConfirmEmailVerification/EMailConfirmationMissing.vue'
import CancelledTariffBanner from '@/components/process/generic/Tariff/CancelledTariffBanner.vue'
import BookedPromoNotificationBanner from '@/components/generic/Promotions/BookedPromoNotificationBanner.vue'
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import IndividualNotificationBanner from '@/components/process/generic/Login/Notifications/IndividualTextBanner.vue'
import substituteSimCardProducts from '@/mixins/substituteSimCardProducts'

export default {
  name: 'NotificationListWrapper',
  components: {
    IndividualNotificationBanner,
    EMailConfirmationMissing,
    CancelledTariffBanner,
    BookedPromoNotificationBanner
  },
  data () {
    return {
      visible: false,
      tariffoptions: null,
      notificationComponents: {
        showEmailBanner: {
          isShown: false
        },
        showCancelledBanner: {
          isShown: false
        },
        showPromotionBanner: {
          isShown: true
        },
        viewIndividualTextNotification: {
          countTextNotifications: 0
        }
      }
    }
  },
  mixins: [
    useFeature('individualTextBanner'),
    useFeature('showAdventNotification'),
    substituteSimCardProducts()
  ],
  computed: {
    inWebView () {
      return window.App !== undefined && window.App.reset !== undefined && window.App.refreshedToken !== undefined
    },
    activeIndividueltextBanner () {
      const actualDate = new Date()
      let isTerminated = false
      if ((this.contractState.contractTerminated) || this.contractState.hasPendingDismissal) {
        isTerminated = true
      }
      if (!this.configIndividualBanner) {
        return false
      }
      return this.configIndividualBanner.filter((note) => {
        if (!isTerminated && !this.contractState.contractPauseActive) {
          return (actualDate > new Date(note.start) && actualDate < new Date(note.end)) || this.individualTextBanner === true
        } else {
          return (actualDate > new Date(note.start) && actualDate < new Date(note.end) && isTerminated === note.viewOnTerminated && this.contractState.contractPauseActive === note.viewOnPaused) || this.individualTextBanner === true
        }
      })
    },
    countIndividueltextBanner () {
      return this.activeIndividueltextBanner.length || 0
    },
    showSingleNotification: function () {
      if (!this.contractState.loadedContractState) {
        return 0
      }
      let count = this.showAboOptionPromotion ? 1 : 0
      // Cancel Tariff
      if (this.contractState.contractTerminated || this.contractState.contractCancelled || (this.contractState.hasPendingDismissal)) {
        count++
      }
      // IndividualTextNotification
      if (this.activeIndividueltextBanner.length > 0) {
        count = count + this.countIndividueltextBanner
      }
      // Email Confirmation
      if (this.currentCustomerContract.emailVerified === false) {
        count++
      }
      if (this.notificationComponents.showPromotionBanner.isShown) {
        count++
      }
      // Free Esim Notification
      if (this.showFreeEsimNotification) {
        count++
      }
      // advent calender Notification
      if (this.showAdventNotification) {
        count++
      }
      return count
    },
    counter: function () {
      let count = this.showAboOptionPromotion ? 1 : 0
      Object.entries(this.notificationComponents).forEach((comp) => {
        if (comp[1].isShown === true) {
          count = count + 1
        }
      })
      if (this.activeIndividueltextBanner.length > 0) {
        count = count + this.countIndividueltextBanner
      }
      if (this.showFreeEsimNotification) {
        count++
      }
      // advent calender Notification
      if (this.showAdventNotification) {
        count++
      }
      return count
    },
    slotData: function () {
      return {
        notifications: this.counter,
        freeReplacementDaysLeft: this.freeSimReplacementDaysLeft,
        freeReplacementLastDate: this.formattedFreeSimReplacementLastDate
      }
    },
    configAbooptionPromotion: function () {
      let config = {}
      try {
        config = JSON.parse(this.getSlotText('configAbooptionPromotion'))
      } catch (e) {
        config = {
          start: 'May 24, 2023 12:00:00 AM GMT+02:00',
          end: 'Jun 26, 2023 11:59:59 PM GMT+02:00'
        }
      }
      return config
    },
    configIndividualBanner: function () {
      let config = []
      try {
        config = JSON.parse(this.getSlotText('configIndividualBanner'))
      } catch (e) {
        config = [
          {
            name: 'CATCH',
            button: false,
            start: '2023-10-20T00:00:00+02:00',
            end: '2023-10-30T23:59:59+01:00',
            viewOnTerminated: true,
            viewOnPaused: true
          },
          {
            name: 'ME',
            button: false,
            start: '2023-11-20T00:00:00+02:00',
            end: '2023-11-30T23:59:59+01:00',
            viewOnTerminated: true,
            viewOnPaused: true
          }
        ]
      }
      return config
    },
    showAboOptionPromotion: function () {
      if (!this.contractState.loadedContractState || this.contractState.contractCancelled || this.contractState.contractTerminated || this.contractPauseActive) {
        return false
      }
      if (!this.configAbooptionPromotion) {
        return false
      }
      const start = new Date(this.configAbooptionPromotion.start).getTime()
      const end = new Date(this.configAbooptionPromotion.end).getTime()
      const currentDate = new Date().getTime()
      const bookedAboOptions = this.tariffoptions?.bookedTariffoptions?.bookedTariffoptions.filter(tariffOption => tariffOption.automaticExtension) || []
      if ((currentDate >= start && currentDate <= end) && (this.has5GBOption || bookedAboOptions.length === 0)) {
        return true
      }
      return false
    },
    showFreeEsimNotification: function () {
      return this.currentCustomerContract?.contract?.simCard?.type === 'SIM_CARD' && this.isEsimFree
    },
    has5GBOption: function () {
      return this.tariffoptions?.bookedTariffoptions?.bookedTariffoptions.find(tariffOption => parseInt(tariffOption.tariffoptionId) === 3070138) !== undefined || false
    },
    aboPromoSlot: function () {
      if (this.has5GBOption) {
        return 'txtNotificationBookedAbooptionPromotion'
      } else {
        return 'txtNotificationAbooptionPromotion'
      }
    },
    esimTargetUrl: function () {
      return this.$slots.urlNotificationFreeEsimAvailable?.[0]?.text || ''
    }
  },
  apollo: {
    tariffoptions: function () {
      return wrapQuery(
        gql`query tariffoptions {
           tariffoptions {
            bookedTariffoptions {
              bookedTariffoptions {
                automaticExtension
                tariffoptionId
                statusKey
              }
            }
          }
        }`, this, ['tariffoptions']
      )
    }
  },
  props: {
    promoIdList: {
      type: [String, Number],
      default: '0'
    },
    extraData: {
      type: Object,
      default: () => {
      }
    },
    contractState: {
      type: Object,
      default: () => {
      }
    },
    currentCustomerContract: {
      type: Object,
      default: () => {
      }
    }
  }
}
</script>
